export default "__VITE_ASSET__CE0C_P0y__"